import React, { useState, useEffect, useCallback } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { ErrorMessage, Field } from 'formik';
import { Field as ChakraField } from '@/components/ui/field';

function FormInput(field) {
  const { indices, name, label, type, value, onChange, onBlur, debounceDelay = 300, numericOnly, ...rest } = field;
  const fieldName = typeof name === 'function' ? name(indices) : name;

  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const handleChange = useCallback(
    e => {
      setLocalValue(numericOnly ? e.target.value.replace(/\D/g, '') : e.target.value);
    },
    [numericOnly]
  );

  return (
    <Box w="full">
      <ChakraField display="flex" flexDir="column" label={label}>
        <Field>
          {({ form: { setFieldValue } }) => {
            useEffect(() => {
              const timeout = setTimeout(() => {
                if (localValue !== value) {
                  setFieldValue(fieldName, localValue);
                  if (onChange) {
                    onChange(fieldName, localValue, setFieldValue);
                  }
                }
              }, debounceDelay);

              return () => clearTimeout(timeout);
            }, [localValue, fieldName, setFieldValue]);

            return (
              <Box w="full">
                <input
                  {...{
                    type,
                    name: fieldName,
                    value: localValue,
                    style: {
                      borderColor: '#ccc',
                      paddingLeft: rest.px || rest.pl || rest.paddingLeft || '11px',
                      paddingRight: rest.px || rest.pr || rest.paddingRight || '11px',
                      paddingTop: rest.py || rest.pt || rest.paddingTop || '6px',
                      paddingBottom: rest.py || rest.pb || rest.paddingBottom || '6px',
                      lineHeight: rest.lineHeight || '21px',
                    },
                    className: 'form-control',
                    onChange: handleChange,
                    onBlur: e => {
                      // Immediately update parent state on blur
                      const finalValue = numericOnly ? e.target.value.replace(/\D/g, '') : e.target.value;
                      if (finalValue !== value) {
                        setFieldValue(fieldName, finalValue);
                        if (onChange) {
                          onChange(fieldName, finalValue, setFieldValue);
                        }
                      }
                      if (onBlur) {
                        onBlur(fieldName, finalValue, setFieldValue);
                      }
                    },
                    ...rest,
                  }}
                />
              </Box>
            );
          }}
        </Field>
      </ChakraField>
      <ErrorMessage name={fieldName}>{msg => <Text color="error">{msg}</Text>}</ErrorMessage>
    </Box>
  );
}

export default FormInput;
